import React, { Component } from "react";
import { Badge, Button, Heading, Pane, Text, TextInput, toaster } from "evergreen-ui";

import Request from "../../../util/Api";

// Legacy product tag picker. Mirrors the v2 MultiSelect behavior: select
// existing tags or type a new name to create one on the fly. Value is an array
// of tag ids; onChange emits the next array. Self-fetches /v2/tags (the same
// endpoint the v2 admin uses) — there's no legacy tags module.
export default class TagsField extends Component {
  constructor(props) {
    super(props);
    this.state = { available: [], input: "", loading: true, creating: false };
  }

  async componentDidMount() {
    try {
      const res = await Request.get("/v2/tags", null, {
        _start: 0,
        _end: 1000,
        _sort: "name",
        _order: "ASC",
      });
      this.setState({ available: res.data || [], loading: false });
    } catch (e) {
      this.setState({ loading: false });
      toaster.danger("Nu am putut incarca etichetele.");
    }
  }

  get selectedIds() {
    return this.props.value || [];
  }

  selectedTags() {
    const byId = new Map(this.state.available.map((t) => [t.id, t]));
    // Keep ids whose tag isn't loaded yet as a minimal fallback so the chip
    // still renders (e.g. just after create, before a refetch).
    return this.selectedIds.map((id) => byId.get(id) || { id, name: `#${id}` });
  }

  add(id) {
    if (this.selectedIds.includes(id)) return;
    this.props.onChange([...this.selectedIds, id]);
  }

  remove(id) {
    this.props.onChange(this.selectedIds.filter((x) => x !== id));
  }

  async addOrCreate() {
    const name = this.state.input.trim();
    if (!name) return;

    const existing = this.state.available.find(
      (t) => t.name.toLowerCase() === name.toLowerCase()
    );
    if (existing) {
      this.add(existing.id);
      this.setState({ input: "" });
      return;
    }

    this.setState({ creating: true });
    try {
      const res = await Request.post("/v2/tags", null, null, {
        name,
        active: true,
      });
      const tag = res.data;
      this.setState((s) => ({
        available: [...s.available, tag],
        input: "",
        creating: false,
      }));
      this.add(tag.id);
    } catch (e) {
      this.setState({ creating: false });
      toaster.danger(
        e && e.fields && e.fields.slug === "duplicate"
          ? "Exista deja o eticheta cu acest nume."
          : "Eticheta nu a putut fi creata."
      );
    }
  }

  render() {
    const selected = this.selectedTags();
    const input = this.state.input.trim().toLowerCase();
    const suggestions = this.state.available
      .filter((t) => !this.selectedIds.includes(t.id))
      .filter((t) => !input || t.name.toLowerCase().includes(input))
      .slice(0, 12);
    const hasExact = this.state.available.some(
      (t) => t.name.toLowerCase() === input
    );

    return (
      <Pane>
        <Heading size={500} marginBottom={8}>
          Etichete
        </Heading>

        <Pane display="flex" flexWrap="wrap" gap={6} marginBottom={8}>
          {selected.length === 0 && (
            <Text color="muted" size={300}>
              Nicio eticheta selectata.
            </Text>
          )}
          {selected.map((t) => (
            <Badge
              key={t.id}
              color="blue"
              isInteractive
              onClick={() => this.remove(t.id)}
              title="Click pentru a elimina"
            >
              {t.name} ✕
            </Badge>
          ))}
        </Pane>

        <Pane display="flex" gap={6} marginBottom={8}>
          <TextInput
            flex={1}
            width="100%"
            placeholder="Cauta sau scrie o eticheta noua"
            value={this.state.input}
            onChange={(e) => this.setState({ input: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                this.addOrCreate();
              }
            }}
          />
          <Button
            type="button"
            appearance="primary"
            isLoading={this.state.creating}
            disabled={!this.state.input.trim()}
            onClick={() => this.addOrCreate()}
          >
            {input && !hasExact ? "Creeaza" : "Adauga"}
          </Button>
        </Pane>

        <Pane display="flex" flexWrap="wrap" gap={6}>
          {this.state.loading ? (
            <Text color="muted" size={300}>
              Se incarca etichetele...
            </Text>
          ) : (
            suggestions.map((t) => (
              <Badge
                key={t.id}
                color="neutral"
                isInteractive
                onClick={() => this.add(t.id)}
                title="Click pentru a adauga"
              >
                {t.name}
              </Badge>
            ))
          )}
        </Pane>
      </Pane>
    );
  }
}
